import type { ReactNode } from 'react';
import { Toaster } from '@/shared/ui/sonner';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

/**
 * Every provider the app needs.
 *
 * Shorter than the other portals by exactly the things a session needs: no
 * Redux store, and no session restorer running a refresh on boot. This portal
 * has no session to restore.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <ThemeProvider>
        {children}
        <Toaster richColors closeButton />
      </ThemeProvider>
    </QueryProvider>
  );
}

export { useTheme } from './ThemeProvider';
